import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import App from './features/app';

ReactDOM.render(<App />, document.getElementById('root'));
